import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import mapboxgl, { Map } from 'mapbox-gl';

@Component({
    selector: 'location',
    templateUrl: './location.component.html',
    styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {

    @Input() info : any;
    @Input() title : any = true;
    @Input() plain : any = false;
    @Input() template : any = 'default';
    @HostBinding('className') className = '';


    isMobile = false;
    points = null;

    accessToken = environment.mapbox.accessToken;

    map:mapboxgl.Map;

    constructor( 
    ){
    }

    ngOnInit(){
        this.className = 'template-'+this.template;
        //this.info.address.exact = false;

        this.points = {
            "type": "FeatureCollection",
            "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
            "features": [{
              "type": "Feature",
              "geometry": {
                  "type": "Point",
                  "coordinates": [this.info.address.location.lon,this.info.address.location.lat]
              }
            }]
        };
    }

    openMap(data: any) {
        window.open('https://www.google.com/maps/?z=19&q=' + (data?.address?.location ?  data?.address?.location?.lat + ',' + data?.address?.location?.lon : data.addressText), '_blank'); 
    }

    mapAction(event){

        if(event instanceof Map){
          this.map = event;
        }
    }


    gotoCenter(address){
        this.map.flyTo({
          center: [address.location.lon, address.location.lat]
        });
    }

}